<template>
  <el-dialog
      :visible.sync="dialogVisible"
      close-on-click-modal
      title="操作记录"
      width="600px"
      style="padding: 0"
      top="5vh">
    <el-table
        ref="elTable"
        v-loading="contentLoading"
        :data="tableData">
      <el-table-column type="index" align="center" label="序号" width="50"/>
      <el-table-column prop="operationTypeDesc" align="center" label="操作类型"/>
      <el-table-column prop="updateName" align="center" label="操作人"/>
      <el-table-column prop="updateTime" align="center" label="操作时间"/>
    </el-table>
  </el-dialog>
</template>
<script>

  export default {
    name: "EsopOperationRecord",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        tableData: [],
        filter: {
          pageSize: 1000,
          billType: 2,
          operationType: "",
          billId: "",
          operationDetails: "",
          updateDate: "",
          startDate: "",
          endDate: "",
        },
      };
    },
    methods: {
      open(id) {
        this.filter.billId = id;
        this.getData();
        this.dialogVisible = true;
      },
      getData() {
        this.contentLoading = true;
        this.$http.post("basic", "billOperationRecords/page", this.filter).then(res => {
          this.tableData = res.records;
        }).finally(() => {
          this.contentLoading = false;
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
